import React from 'react';
import { Link } from 'react-router-dom';
import { setCookieValue } from 'utils/cookies';
import { StyledNav } from './styled';

const LanguagesNav = ({languages, activeLang}) => {
  if (languages && languages.length > 1) {
    return (
      <StyledNav>
        <ul>
          {
            languages.filter(lang => lang._id !== activeLang)
            .map((lang, i) => (
              <li key={lang._id}>
                <Link to={lang.path} title={lang.name} onClick={() => {
                  setCookieValue('language', lang._id);
                }}>
                  {lang._id.toUpperCase()}
                </Link>
              </li>
            ))
          }
        </ul>
      </StyledNav>
    );
  }
  return null;
};

export default LanguagesNav;



// WEBPACK FOOTER //
// ./src/modules/Header/components/LanguagesNav/LanguagesNav.jsx